import React from "react";
import { Grid, Typography } from "@mui/material";
import { NumericTextBox } from "@progress/kendo-react-inputs";

const PlanAssumptions = (props) => {

  function createData(year, age, totalCurrent, totalPortential, increase) {
    return { year, age, totalCurrent, totalPortential, increase };
  }

  const rows = [
    createData(10, 69, 666306, 777780, 177455),
    createData(10, 69, 666306, 777780, 177455),
    createData(10, 69, 666306, 777780, 177455),
    createData(10, 69, 666306, 777780, 177455),
    createData("", 69, 666306, 777780, 177455),
  ];


  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography component={"h1"}>Tax Settings</Typography>
      </Grid>

      <Grid item xs={12}>
        <NumericTextBox
          label={"COLA"}
          value={props.assumptions.cola}
          format={"0.00%"}
          min={0}
          max={1}
          step={0.01}
          onChange={props.update("cola")}
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <NumericTextBox
          label={"SS COLA"}
          value={props.assumptions.ssCola}
          format={"0.00%"}
          min={0}
          max={1}
          step={0.01}
          onChange={props.update("ssCola")}
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={12}>
          <NumericTextBox
            label={"Pension COLA"}
            format={"0.00%"}
            value={props.assumptions.pensionCola}
            onChange={props.update("pensionCola")}
            min={0}
            max={0.1}
            step={0.01}
            disabled={props.readOnly}
          />
      </Grid>
      <Grid item xs={12}>
        <NumericTextBox
          label={"State Taxes"}
          value={props.assumptions.stateTax}
          format={"0.00%"}
          min={0}
          max={1}
          step={0.01}
          onChange={props.update("stateTax")}
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <NumericTextBox
          label={"Capital Gains Tax"}
          value={props.assumptions.capitalGainsTax}
          format={"0.00%"}
          min={0}
          max={1}
          step={0.01}
          onChange={props.update("capitalGainsTax")}
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <NumericTextBox
          label={"FICA Tax"}
          value={props.assumptions.ficaTax}
          format={"0.00%"}
          min={0}
          max={1}
          step={0.01}
          onChange={props.update("ficaTax")}
          disabled={props.readOnly}
        />
      </Grid>
    </Grid>
  );
};

export default PlanAssumptions;
